var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStandardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6618 12.6555C14.6618 13.365 12.9209 15.3518 9.72824 15.3518C6.53572 15.3517 4.72921 13.365 4.72921 12.6555V10.3147L9.01437 12.6555C9.44006 12.8897 9.95099 12.8897 10.3767 12.6555L14.6618 10.3147V12.6555ZM9.01437 4.17018C9.43994 3.94321 9.95106 3.94334 10.3767 4.17018L17.1316 7.8528C17.3583 7.98051 17.4996 8.21454 17.4997 8.47682V13.0247C17.4997 13.4148 17.1809 13.7346 16.7907 13.7346C16.4005 13.7346 16.0808 13.4149 16.0808 13.0247V8.83131L10.3767 11.9465C9.95104 12.1805 9.43996 12.1806 9.01437 11.9465L3.0339 8.68287C2.54436 8.41327 2.54436 7.70345 3.0339 7.43385L9.01437 4.17018Z",
    fill: "#84849A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardIcon);
export default __webpack_public_path__ + "static/media/standard-icon.00fe215c.svg";
export { ForwardRef as ReactComponent };